const STALE_TIME = {
    $15Seconds: 24 * 1000,
    $30Seconds: 30 * 1000,
    $1Minute: 60 * 1000,
    $3Minutes: 3 * 60 * 1000,
    $5Minutes: 5 * 60 * 1000,
    $10Minutes: 10 * 60 * 1000,
    $30Minutes: 30 * 60 * 1000,
    $1Hour: 60 * 60 * 1000,
    $2Hours: 2 * 60 * 60 * 1000,
    $1Day: 24 * 60 * 60 * 1000,
};

export { STALE_TIME };
